export default __webpack_public_path__ + "media/images/images_v2/top-shadeliste-c49d41583dad62052be7add7204ae644.png";